import { PessoaResponse } from '../../responses/pessoa/pessoa.response';
import { MunicipioItem } from '../../apis/usuario/municipio.service';

/**
 * Dados do sacado (cliente) para emissão de boleto, enviados ao backend junto com a
 * criação/edição de contas a receber. Espelha o SacadoBoletoStruct do backend.
 */
export class SacadoBoletoStruct {
    sacadoNome: string = '';
    sacadoCpfCnpj: string = '';
    sacadoEmail: string | null = null;
    sacadoTelefone: string | null = null;
    sacadoCelular: string | null = null;
    sacadoEnderecoLogradouro: string = '';
    sacadoEnderecoNumero: string = '';
    sacadoEnderecoComplemento: string | null = null;
    sacadoEnderecoBairro: string = '';
    sacadoEnderecoCep: string = '';
    sacadoEnderecoCidade: string = '';
    sacadoEnderecoUf: string = '';

    /**
     * Monta o sacado a partir da resposta completa da Pessoa. Endereço: prioriza o de cobrança,
     * depois o principal. Cidade/UF vêm do lookup de município (descricao "Cidade - UF").
     */
    static fromPessoaResponse(resp: PessoaResponse, municipio: MunicipioItem): SacadoBoletoStruct {
        const s = new SacadoBoletoStruct();
        const p = resp?.pessoa;
        if (!p) return s;

        s.sacadoNome = p.nome ?? '';
        s.sacadoCpfCnpj = (p.cnpj || p.cpf) ?? '';
        s.sacadoEmail = p.emailNFe ?? null;
        s.sacadoTelefone = p.telefone ?? null;
        s.sacadoCelular = p.telefone ?? null;

        const enderecos = resp.enderecos ?? [];
        const end = enderecos.find(e => e.isCobranca) ?? enderecos.find(e => e.isPrincipal) ?? enderecos[0];
        if (end) {
            s.sacadoEnderecoLogradouro = end.logradouro ?? '';
            s.sacadoEnderecoNumero = end.numero ?? '';
            s.sacadoEnderecoComplemento = end.complemento ?? null;
            s.sacadoEnderecoBairro = end.bairro ?? '';
            s.sacadoEnderecoCep = end.cep ?? '';
        }

        s.sacadoEnderecoCidade = municipio.nome;
        s.sacadoEnderecoUf = municipio.uf ?? '';

        return s;
    }
}
